import ItemsDetailsMobileWrapper from 'components/ItemsDetailsMobileWrapper'
import ItemHeader from 'containers/ManageAccess/ItemHeader'
import { useIsSmallScreen } from 'packages/core'
import { Loader } from 'packages/eid-ui'
import {
    useCheckMailboxAccessByAssignmentId,
    useMailbox,
    useTargetPerson,
} from 'hooks'
import MailboxDetails from './MailboxDetails'
import { ManageAccessDrawer } from 'components/Drawer/ManageAccessDrawer'

const MailboxesDrawer = ({ id, attributes, toggleDrawer, ...rest }) => {
    const isSmallScreen = useIsSmallScreen()
    const headerAttribute = attributes.find((x) => x.isHeader)

    const [targetPerson] = useTargetPerson()

    const { data: assignmentStatus } = useCheckMailboxAccessByAssignmentId(
        id,
        targetPerson.id,
    )

    const { data: mailbox } = useMailbox(id, true)

    let item
    if (mailbox && assignmentStatus) {
        item = {
            resource: mailbox,
            assignment: assignmentStatus,
        }
    }

    const itemDetails = <MailboxDetails item={item} {...rest} />

    return isSmallScreen ? (
        <ItemsDetailsMobileWrapper toggleDrawer={toggleDrawer}>
            <ItemHeader title={item?.resource?.[headerAttribute.name]} />
            {!item && <Loader />}
            {item && itemDetails}
        </ItemsDetailsMobileWrapper>
    ) : (
        <ManageAccessDrawer
            id={id}
            toggleDrawer={toggleDrawer}
            item={item}
            itemDetails={itemDetails}
            headerAttribute={headerAttribute}
        />
    )
}

export default MailboxesDrawer
